"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientType = void 0;
/**
 * The type of client.  Whether they are a bank, broker, or credit union.
 */
var ClientType;
(function (ClientType) {
    ClientType["BANK"] = "BANK";
    ClientType["BROKER"] = "BROKER";
    ClientType["CREDITUNION"] = "CREDITUNION";
})(ClientType = exports.ClientType || (exports.ClientType = {}));
